import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, FormCheck } from 'react-bootstrap';
import ObservationValidationHistoryTable from '@awp/tables/observationValidationHistoryTable';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import { IconCaretDownFill, IconCaretRightFill } from '@components/awpIcons';

function ValidationDataTypeView({
  selectedDataSet,
  handleSegmentObservationTypes,
  getValidationHist,
  setIsClickedView,
}) {
  const [isValid, setIsValid] = useState('');
  const [validationHistRequest, setValidationHistRequest] = useState({});
  const [showLog, setShowLog] = useState(false);
  const selectedDataSetId = selectedDataSet.DatasetId; //[DATASET_PREFIX]_[OBSERVATION_TYPE_ID]_[SENSOR_PLACEMENT_ID |CAMERA_ID | WEATHER_FORECAST_TYPE_ID]
  const currentDataSet = selectedDataSetId.split('_');
  const selectedDataSetDisplayName = selectedDataSet.DisplayName; //observation type display name
  const selectedDataSetSensorLayerNumber = selectedDataSet.SensorLayerNumber;

  const handleIsValidChange = (e) => {
    e.preventDefault;
    if (isValueEmpty(e) || isValueEmpty(e.target) || isValueEmpty(e.target.id)) return;
    let segmentObservationType = {
      ObservationTypeId: currentDataSet[1],
      IsValid: 'y',
      SensorPlacementId: currentDataSet[2],
      SensorLayerNumber: selectedDataSetSensorLayerNumber,
    };
    if (e.target.id.endsWith('_isValid_no_change') && e.target.checked) {
      setIsValid('');
      segmentObservationType.IsValid = '';
      handleSegmentObservationTypes(segmentObservationType);
      setIsClickedView();
      return;
    }
    if (e.target.id.endsWith('_isValid_valid') && e.target.checked) {
      setIsValid('y');
      handleSegmentObservationTypes(segmentObservationType);
      setIsClickedView();
      return;
    }
    if (e.target.id.endsWith('_isValid_invalid') && e.target.checked) {
      setIsValid('n');
      segmentObservationType.IsValid = 'n';
      handleSegmentObservationTypes(segmentObservationType);
      setIsClickedView();
      return;
    }
  };

  const getRequestDto = () => {
    let dto = getValidationHist();
    dto.ObservationTypeId = currentDataSet[1];
    dto.SensorPlacementId = currentDataSet[2];
    dto.SensorLayerNumber = selectedDataSetSensorLayerNumber;
    setValidationHistRequest(dto);
    setShowLog(!showLog);
  };
  return (
    <div>
      <Row
        style={{
          fontSize: '12px',
          marginLeft: '0',
          marginRight: '0',
          marginBottom: '0',
          borderBottom: '1px solid rgba(0,0,0,0.3)',
          paddingTop: '4px',
          paddingBottom: '4px',
        }}
      >
        <Col xs={1}>
          <span>
            {showLog ? <IconCaretDownFill onClick={getRequestDto} /> : <IconCaretRightFill onClick={getRequestDto} />}
          </span>
        </Col>
        <Col xs={4}>{selectedDataSetDisplayName}</Col>
        <Col xs={3}>
          <FormCheck
            inline
            type="radio"
            name={`radioName_${selectedDataSetId}`}
            id={`${selectedDataSetId}_isValid_no_change`}
            checked={isValueEmpty(isValid) ? true : false}
            onChange={handleIsValidChange}
            label="No Change"
          />
        </Col>
        <Col xs={2}>
          <FormCheck
            inline
            type="radio"
            id={`${selectedDataSetId}_isValid_valid`}
            name={`radioName_${selectedDataSetId}`}
            checked={isValid == 'y' ? true : false}
            onChange={handleIsValidChange}
            label="Valid"
          />
        </Col>
        <Col xs={2}>
          <FormCheck
            inline
            type="radio"
            name={`radioName_${selectedDataSetId}`}
            id={`${selectedDataSetId}_isValid_invalid`}
            checked={isValid == 'n' ? true : false}
            onChange={handleIsValidChange}
            label="Invalid"
          />
        </Col>
      </Row>
      {showLog && <Row style={{ height: '1rem' }} />}
      <Row style={{ marginLeft: '1em', marginRight: '1em' }}>
        <Col md={12}>
          <div className="dataTables-table dataTables overflow-auto" style={{ fontSize: '12px' }}>
            {showLog && (
              <ObservationValidationHistoryTable
                idx={`tbl_log_${selectedDataSetId}`}
                requestDTO={validationHistRequest}
              />
            )}
          </div>
        </Col>
      </Row>
      {showLog && <Row style={{ height: '1rem', borderBottom: '1px solid rgba(0,0,0,0.3)' }} />}
    </div>
  );
}

ValidationDataTypeView.propTypes = {
  selectedDataSet: PropTypes.object,
  handleSegmentObservationTypes: PropTypes.any,
  getValidationHist: PropTypes.func,
};

export default ValidationDataTypeView;
